import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';

import { MegaMenuProvider } from './lib/MegaMenuContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <MegaMenuProvider>
        <App />
    </MegaMenuProvider>
);
// root.render(
//   <React.StrictMode>
//     <MegaMenuProvider>
//         <App />
//     </MegaMenuProvider>
//   </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
